<template>
  <div>
    <button
      type="button"
      class="btn btn-link p-0 d-inline-flex align-items-center gap-2 text-decoration-none"
      :aria-expanded="guideOpen"
      :aria-controls="guideBodyId"
      @click="guideOpen = !guideOpen"
    >
      <FontAwesomeIcon icon="fa-regular fa-circle-info" />
      <span class="fw-semibold">{{
        $t("forwards.pools.eligibility.guide.title")
      }}</span>
      <FontAwesomeIcon :icon="guideOpen ? 'chevron-down' : 'chevron-right'" />
    </button>
    <div v-show="guideOpen" :id="guideBodyId" class="mt-2">
      <p class="mb-1">{{ $t("forwards.pools.eligibility.guide.intro") }}</p>
      <ul class="mb-2">
        <li>{{ $t("forwards.pools.eligibility.guide.unsupported") }}</li>
        <li>{{ $t("forwards.pools.eligibility.guide.biomass") }}</li>
        <li>{{ $t("forwards.pools.eligibility.guide.issuance") }}</li>
      </ul>
      <p class="mb-0" data-testid="eligibility-guide-several-pools">
        {{
          $t("forwards.pools.eligibility.guide.several_pools", {
            option: $t("forwards.pools.devices.use_allowlist"),
            section: $t("forwards.pools.devices.title"),
          })
        }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, useId } from "vue";

/**
 * How to group a pool's devices so that none keeps the pool out of a deal, collapsible below the
 * pool editor's deal eligibility table, whose values it explains how to improve. It names the device
 * section's own labels, so the hint follows them when they are renamed.
 */
const guideBodyId = useId();

// Collapsed on every mount, as the forward sales guide (user decision, 2026-10-13).
const guideOpen = ref(false);
</script>
